import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './job-card.module.css';
import {formatDistanceToNow} from 'date-fns';


const JobCard = ({ index, job, onApplyJob, applied }) => {
    const navigate = useNavigate();
    const [postedDate,setPostedDate] = useState('');

    useEffect(() => {
        //  console.log("job.createdAt:", (job.createdAt))
            setPostedDate(formatDistanceToNow(new Date(job.createdAt), {addSuffix: true}))
            // console.log("postedDate:",postedDate)
        // }
    }, []);
    
    const handleJobClick = (jobId) => {
        navigate(`/guests/job-details/${jobId}`);
    };

    const handleApplyClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
        onApplyJob(job._id);
        navigate('/signup')
    };

    return (
        <div className={styles.jobCard} key={index} onClick={() => handleJobClick(job._id)}>
            <div className={styles.jobHeader}>
                <div className={styles.companyInfo}>
                    <img 
                        src={job.company.logo} 
                        alt={`${job.company.name} logo`} 
                        className={styles.jobLogo} 
                    />
                    <div className={styles.titleSection}>
                        <h3 className={styles.jobTitle}>{job.title}</h3>
                        <p className={styles.jobCompany}>{job.company.name}</p>
                    </div>
                </div>
                <div className={styles.locationBadge}>
                    <span className={styles.locationIcon}>📍</span>
                    <span className={styles.jobLocation}>
                        {job.location?.replace(/,/g, '').split(' ').slice(0, 2).join(' ')}
                    </span>
                </div>
            </div>

            <div className={styles.jobContent}>
                <p className={styles.jobDescription}>
                    {job.description.split('\n').slice(0, 3).join(' ').substring(0, 150)}
                    {job.description.length > 150 ? '...' : ''}
                </p>
            </div>

            <div className={styles.jobFooter}>
                <div className={styles.jobMeta}>
                    <span className={styles.jobType}>Full-time</span>
                    <span className={styles.jobPosted}>{postedDate}</span>
                </div>
                <button
                    className={`${styles.applyButton} ${applied ? styles.applied : ''}`}
                    onClick={handleApplyClick}
                >
                    {applied ? (
                        <>
                            <span className={styles.checkIcon}>✓</span>
                            Applied
                        </>
                    ) : (
                        'Apply Now'
                    )}
                </button>
            </div>
        </div>
    );
};

export default JobCard;
